// extracted by mini-css-extract-plugin
export default {"darkButton":"button_darkButton__HATMR","lightButton":"button_lightButton__Mhp7e"};